import Keycloak, { KeycloakConfig } from 'keycloak-js';
import { resetUser } from 'models/user';
import { getAppAbsoluteUrl } from './routes';

const keycloakConfig: KeycloakConfig = {
  url: process.env.REACT_APP_KC_HOST || 'http://localhost:8080',
  realm: process.env.REACT_APP_KC_REALM || 'myrealm',
  clientId: process.env.REACT_APP_KC_CLIENT_ID || 'myclient',
};

class KeycloakInstance {
  private static instance: Keycloak | null = null;

  public static getInstance(): Keycloak {
    if (!KeycloakInstance.instance) {
      KeycloakInstance.instance = new Keycloak(keycloakConfig);
    }
    return KeycloakInstance.instance;
  }
}

/**
 * URL выхода из Keycloak без id_token_hint (короткий URL).
 * Стандартный keycloak.logout() подставляет в URL полный id_token с группами → 414 Request-URI Too Large при многих группах.
 */
export function getKeycloakLogoutUrl(
  kc: Keycloak,
  postLogoutRedirectUri: string = getAppAbsoluteUrl('/login'),
): string {
  const base = `${kc.authServerUrl}/realms/${kc.realm}/protocol/openid-connect/logout`;
  const params = new URLSearchParams({
    client_id: kc.clientId || '',
    post_logout_redirect_uri: postLogoutRedirectUri,
  });
  return `${base}?${params.toString()}`;
}

/**
 * Выход из Keycloak через короткий URL (без id_token_hint), чтобы избежать 414 при большом числе групп.
 */
export function keycloakLogoutWithoutIdTokenHint(
  kc: Keycloak,
  postLogoutRedirectUri?: string,
): void {
  resetUser();
  window.location.href = getKeycloakLogoutUrl(kc, postLogoutRedirectUri);
}

const LOGOUT_URL_SAFE_LENGTH = 6000;

/**
 * Выход: при коротком id_token — keycloak.logout(). При большом числе групп id_token длинный → короткий URL без hint (иначе 414).
 */
export function keycloakLogout(kc: Keycloak, postLogoutRedirectUri?: string): void {
  const redirectUri = postLogoutRedirectUri ?? getAppAbsoluteUrl('/login');
  const idToken = kc.idToken;
  const wouldBeLong =
    !idToken ||
    getKeycloakLogoutUrl(kc, redirectUri).length + idToken.length > LOGOUT_URL_SAFE_LENGTH;

  if (wouldBeLong) {
    keycloakLogoutWithoutIdTokenHint(kc, postLogoutRedirectUri);
    return;
  }
  resetUser();
  kc.logout({ redirectUri });
}

export default KeycloakInstance.getInstance();
